import colors from 'fincraft-lib-basics/src/js/colors'

const setColor = function (chart) {
  chart.series.forEach(series => {
    //TODO use Performance plugin
    const {color, finAutoColor} = series.options
    if (color !== 'auto' && !finAutoColor) return
    const points = series.points
    if(points && !points.length){
      return
    }
    const startPoint = points[0] // start point
    const endPoint = points[points.length - 1] // end point
    const differenceY = endPoint.y - startPoint.y // difference between first and last points "y"
    const newColor= differenceY === 0 ? colors["french-blue"] : differenceY < 0 ? colors["pale-red"] : colors["soft-green"]
    if(color!==newColor){
      series.update({finAutoColor: true, color:newColor})
    }

  })

}

export default function (H) {
  H.addEvent(H.Chart, 'render', function (e) {
    const chart = e.target
    setColor(chart)
  })
}
